import { Container, Row, Col } from 'react-bootstrap';

function About() {
  return (
    <Container>
      <Row className='about-us' style={{ color: '#FFF', justifyContent: 'center' }}>
        <Col xs={12} sm={12} md={10} lg={10} className='about-us-col' style={{ margin: '0 auto', textAlign: 'left' }}>
          <div className='about-us-text' style={{ maxWidth: '100%', display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
            <div className='about-us-title text-primary-color' style={{ fontSize: 36, textAlign: 'center', width: '100%' }}>
              O QUE A GENTE PODE FAZER PELA SUA EMPRESA?
            </div>
            <div className='about-us-description'>
              Somos uma parceira valiosa para a sua empresa, ajudando a definir identidade visual, artes gráficas, fotografia, vídeos, criar campanhas publicitárias, e desenvolver estratégias de marketing personalizadas, gerenciar presença nas mídias sociais e analisar dados para maximizar retorno sobre o investimento. Resumindo somos o que você precisa!
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default About